/**
 * Client-side cost calculations — mirrors server/src/services/cost-calculator.ts
 */

export interface CostInputs {
  caseCost: number;
  vendorDiscountPct: number;
  offInvoice: number;
  byCheque: number;
  freeGoods: number;
  packSize: number;
  retailPrice: number;
}

export function calculateNetCaseCost(c: CostInputs): number {
  return (
    c.caseCost -
    (c.caseCost * c.vendorDiscountPct) / 100 -
    c.offInvoice -
    c.byCheque -
    c.freeGoods
  );
}

export function calculateUnitCost(c: CostInputs): number {
  const netCase = calculateNetCaseCost(c);
  return netCase / c.packSize;
}

export function calculateMargin(c: CostInputs): number {
  const unitCost = calculateUnitCost(c);
  if (c.retailPrice === 0) return 0;
  return (c.retailPrice - unitCost) / c.retailPrice;
}

export function formatCurrency(value: number | null | undefined): string {
  if (value == null || isNaN(value)) return "$0.00";
  return `$${Number(value).toFixed(2)}`;
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null || isNaN(value)) return "0.0%";
  return `${(Number(value) * 100).toFixed(1)}%`;
}
